import React from 'react';
import { Hero } from '../components/sections/Hero';
import { IntroOffer } from '../components/sections/IntroOffer';
import { LearningSystem } from '../components/sections/LearningSystem';
import { BeforeAfter } from '../components/sections/BeforeAfter';
import { PainPoints } from '../components/sections/PainPoints';
import { Volumes } from '../components/sections/Volumes';
import { Tools } from '../components/sections/Tools';
import { Bonuses } from '../components/sections/Bonuses';
import { ValueStack } from '../components/sections/ValueStack';
import { PurchaseTerms } from '../components/sections/PurchaseTerms';
import { Testimonials } from '../components/sections/Testimonials';
import { Creator } from '../components/sections/Creator';
import { Faq } from '../components/sections/Faq';
import { FinalCta } from '../components/sections/FinalCta';
import { Footer } from '../components/sections/Footer';
import { FloatingCta } from '../components/FloatingCta';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-386" data-mp="35t059hwhk8dp">
      <Hero data-id="element-387" data-mp="30twynt0uxu3m" />
      <main data-id="element-388" data-mp="30tdpb0p9we17">
        <IntroOffer data-id="element-389" data-mp="30t5f5gkjbmtp" />
        <LearningSystem data-id="element-390" data-mp="30ugft7iooegl" />
        <BeforeAfter data-id="element-391" data-mp="30ruazfn6gd22" />
        <PainPoints data-id="element-392" data-mp="2vv3tqozmzbf2" />
        <Volumes data-id="element-393" data-mp="2vvlofh6nhhkv" />
        <Tools data-id="element-394" data-mp="2vw54escqpvw9" />
        <Bonuses data-id="element-395" data-mp="2vwnbyl4urwjh" />
        <ValueStack data-id="element-396" data-mp="2vszfbd442u0j" />
        <PurchaseTerms data-id="element-397" data-mp="3tic8m154tm83" />
        <Testimonials data-id="element-398" data-mp="3thjb7qs2c92m" />
        <Creator data-id="element-399" data-mp="3ti2kkj3ndp51" />
        <Faq data-id="element-400" data-mp="3tghxfejnx8h7" />
        <FinalCta data-id="element-401" data-mp="3ojhsj6yjubro" />
      </main>
      <Footer data-id="element-402" data-mp="3oj82xkhf26mi" />
      <FloatingCta data-id="element-403" data-mp="3oksxha3qdpkd" />
      <PurchasePopup data-id="element-404" data-mp="3okapxhbmbox5" />
    </div>;
}